require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon")) : factory(root["./utils"], root["./svgicon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[18],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(220);


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SingleDatepicker = _interopRequireDefault(__webpack_require__(221));

exports.SingleDatepicker = _SingleDatepicker["default"];

var _RangeDatepicker = _interopRequireDefault(__webpack_require__(227));

exports.RangeDatepicker = _RangeDatepicker["default"];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(53));

var _reactDates = __webpack_require__(94);

var _moment = _interopRequireDefault(__webpack_require__(60));

var _utils = __webpack_require__(4);

var _withCommon = _interopRequireDefault(__webpack_require__(95));

var _dec, _class, _class2, _temp;

var sanitize = _utils.propsUtils.sanitize;
var lang;

if (document.documentElement && document.documentElement.lang) {
  lang = document.documentElement.lang; // The locale key for Norwegian differs between Cognos and Moment

  if (lang === 'no') {
    lang = 'nb';
  }
}

var SingleDatepicker = (_dec = (0, _withCommon["default"])({
  locale: lang
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SingleDatepicker, _Component);

  function SingleDatepicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focused: _this.props.focused,
      lastValidDate: _this.props.date,
      date: _this.props.date
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.setState({
        focused: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focusController", function (toBeFocused) {
      var onFocusChange = _this.props.onFocusChange;
      var _this$state = _this.state,
          typedDate = _this$state.typedDate,
          lastValidDate = _this$state.lastValidDate;

      if (toBeFocused === false) {
        var validTypeDate = lastValidDate;

        if (typedDate && (0, _moment["default"])(typedDate, [_moment["default"].ISO_8601, _moment["default"].RFC_2822]).isValid()) {
          validTypeDate = (0, _moment["default"])(typedDate);
        }

        _this.setState({
          focused: false,
          date: validTypeDate
        });
      }

      onFocusChange && onFocusChange(toBeFocused);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onDateType", function (e) {
      _this.setState({
        typedDate: e.target.value,
        focused: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (selectedDate) {
      var onChange = _this.props.onChange;
      onChange && onChange(selectedDate);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyUp", function (event) {
      event.persist();

      if (event.keyCode === 27 || event.keyCode === 13) {
        _this._focusController(false);
      }
    });
    return _this;
  }

  var _proto = SingleDatepicker.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newState = {};

    if (nextProps.date && nextProps.date.isValid) {
      newState.lastValidDate = nextProps.date;
    }

    newState.date = nextProps.date;
    this.setState(newState);
  };

  _proto._renderMonth = function _renderMonth(month) {
    return month.locale(this.props.locale).format(this.props.commonProps.monthFormat);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        disabled = _this$props.disabled,
        commonProps = _this$props.commonProps,
        placeholder = _this$props.placeholder,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["disabled", "commonProps", "placeholder", "light"]);
    var _this$state2 = this.state,
        date = _this$state2.date,
        focused = _this$state2.focused; // for defect https://jsw.ibm.com/browse/BATOOLKIT-2274

    date && date.locale(lang);
    var cProps = (0, _extends2["default"])({}, sanitize(others, SingleDatepicker), commonProps, {
      disabled: disabled,
      focused: focused,
      date: date,
      placeholder: placeholder,
      onFocusChange: function onFocusChange(_ref) {
        var f = _ref.focused;

        _this2.setState({
          focused: f
        });

        _this2._focusController(!!f);
      },
      onDateChange: this._onChange
    });
    cProps.renderMonth = cProps.renderMonth || this._renderMonth.bind(this);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)('ba-common-datepicker', {
        open: !!focused,
        light: light
      }),
      onFocus: this._onFocus,
      onChange: this._onDateType,
      onKeyUp: function onKeyUp(e) {
        _this2._onKeyUp(e);
      },
      onKeyDown: function onKeyDown(e) {
        e.persist();
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactDates.SingleDatePicker, cProps));
  };

  return SingleDatepicker;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", (0, _extends2["default"])({
  /** momentPropTypes.momentObj */
  date: _reactMomentProptypes["default"].momentObj,

  /** Format */
  renderMonth: _propTypes["default"].func,

  /** View */
  focused: _propTypes["default"].bool,

  /** Callback function */
  onFocusChange: _propTypes["default"].func,

  /** Callback function */
  onChange: _propTypes["default"].func,

  /** Placeholder text when no date is selected */
  placeholder: _propTypes["default"].string
}, (0, _withCommon["default"])()().propTypes)), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  onFocusChange: null,
  focused: false // displayFormat: 'YYYY-MM-DD',

}), _temp)) || _class);
exports["default"] = SingleDatepicker;

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports = require("moment-jalaali");

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _DatePickerResources = _interopRequireDefault(__webpack_require__(224));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_DatePickerResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

var amdi18n={"__root":{"year":"Year"},"__cs":{"year":"Rok"},"__da":{"year":"År"},"__de":{"year":"Jahr"},"__es":{"year":"Año"},"__fi":{"year":"Vuosi"},"__fr":{"year":"Année"},"__hr":{"year":"Godina"},"__hu":{"year":"Év"},"__it":{"year":"Anno"},"__ja":{"year":"年"},"__kk":{"year":"Жыл"},"__ko":{"year":"연도"},"__nb":{"year":"År"},"__nl":{"year":"Jaar"},"__no":{"year":"År"},"__pl":{"year":"Rok"},"__pt":{"year":"Ano"},"__pt-br":{"year":"Ano"},"__ro":{"year":"An"},"__ru":{"year":"Год"},"__sl":{"year":"Leto"},"__sv":{"year":"År"},"__th":{"year":"ปี"},"__tr":{"year":"Yıl"},"__zh":{"year":"年"},"__zh-cn":{"year":"年"},"__zh-hk":{"year":"年"},"__zh-mo":{"year":"年"},"__zh-sg":{"year":"年"},"__zh-tw":{"year":"年"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-datepicker{display:inline-block}.ba-common-datepicker .CalendarDay{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);border:1px solid transparent;padding:0;box-sizing:border-box;cursor:pointer}.ba-common-datepicker .CalendarDay__button{position:relative;height:100%;width:100%;text-align:center;background:none;border:0;margin:0;padding:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;box-sizing:border-box;font-size:12px}.ba-common-datepicker .CalendarDay__button:active{outline:0}.ba-common-datepicker .CalendarDay__button:focus{outline:-webkit-focus-ring-color auto 5px;outline-color:-webkit-focus-ring-color;outline-style:auto;outline-width:5px}.ba-common-datepicker .CalendarDay--highlighted-calendar{background:#ffe8bc;cursor:default}.ba-common-datepicker .CalendarDay--highlighted-calendar:active{background:#007a87}.ba-common-datepicker .CalendarDay--outside{border:0;cursor:default}.ba-common-datepicker .CalendarDay--blocked-minimum-nights{border:1px solid #e4e7e7;cursor:default}.ba-common-datepicker .CalendarDay--selected-span{border:1px double #eaeaea}.ba-common-datepicker .CalendarDay--selected-span.CalendarDay--hovered,.ba-common-datepicker .CalendarDay--selected-span:active{background:#c0bfc0;border:1px double #c0bfc0}.ba-common-datepicker .CalendarDay--selected-span.CalendarDay--last-in-range{border-right:#00a699}.ba-common-datepicker .CalendarDay--after-hovered-start,.ba-common-datepicker .CalendarDay--hovered-span{background:#eaeaea;border:1px double #eaeaea}.ba-common-datepicker .CalendarDay--blocked-calendar{color:#82888a;cursor:default}.ba-common-datepicker .CalendarDay--blocked-out-of-range{cursor:default}.ba-common-datepicker .CalendarMonth{text-align:center;padding:0 13px;vertical-align:top;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ba-common-datepicker .CalendarMonth table{border-collapse:collapse;border-spacing:0;caption-caption-side:initial}.ba-common-datepicker .CalendarMonth--horizontal:first-of-type,.ba-common-datepicker .CalendarMonth--vertical:first-of-type{position:absolute;z-index:-1;opacity:0;pointer-events:none}.ba-common-datepicker .CalendarMonth--horizontal{display:inline-block;min-height:100%}.ba-common-datepicker .CalendarMonth--vertical{display:block}.ba-common-datepicker .CalendarMonth__caption{font-size:12px;text-align:center;margin-bottom:2px;caption-side:initial}.ba-common-datepicker .CalendarMonth--horizontal .CalendarMonth__caption,.ba-common-datepicker .CalendarMonth--vertical .CalendarMonth__caption{padding:16px 0 35px}.ba-common-datepicker .CalendarMonth--vertical-scrollable .CalendarMonth__caption{padding:5px 0}.ba-common-datepicker .CalendarMonthGrid{z-index:0;text-align:left}.ba-common-datepicker .CalendarMonthGrid--animating{-webkit-transition:-webkit-transform 0.2s ease-in-out;-moz-transition:-moz-transform 0.2s ease-in-out;transition:transform 0.2s ease-in-out;z-index:1}.ba-common-datepicker .CalendarMonthGrid--horizontal{position:absolute;left:9px}.ba-common-datepicker .CalendarMonthGrid--vertical{margin:0 auto}.ba-common-datepicker .CalendarMonthGrid--vertical-scrollable{margin:0 auto;overflow-y:scroll}.ba-common-datepicker .DayPicker{position:relative;text-align:left}.ba-common-datepicker .DayPicker--horizontal{box-shadow:0 2px 8px rgba(0,0,0,0.1)}.ba-common-datepicker .DayPicker--horizontal.DayPicker--portal{box-shadow:none;position:absolute;left:50%;top:50%}.ba-common-datepicker .DayPicker--vertical.DayPicker--portal{position:initial}.ba-common-datepicker .DayPicker__focus-region{outline:none}.ba-common-datepicker .DayPicker__week-headers{position:relative}.ba-common-datepicker .DayPicker--horizontal .DayPicker__week-headers{margin-left:9px}.ba-common-datepicker .DayPicker__week-header{color:#757575;position:absolute;z-index:2;padding:0 13px;text-align:left;top:40px}.ba-common-datepicker .DayPicker__week-header ul{list-style:none;margin:1px 0;padding-left:0;padding-right:0}.ba-common-datepicker .DayPicker__week-header li{font-weight:600;display:inline-block;text-align:center}.ba-common-datepicker .DayPicker--vertical .DayPicker__week-header{left:50%}.ba-common-datepicker .DayPicker--vertical-scrollable{height:100%}.ba-common-datepicker .DayPicker--vertical-scrollable .DayPicker__week-header{top:0;display:table-row;border-bottom:1px solid #dbdbdb;background:white}.ba-common-datepicker .DayPicker--vertical-scrollable .transition-container--vertical{padding-top:20px;height:100%;position:absolute;top:0;bottom:0;right:0;left:0;overflow-y:scroll}.ba-common-datepicker .DayPicker--vertical-scrollable .DayPicker__week-header{margin-left:0;left:0;width:100%;text-align:center}.ba-common-datepicker .transition-container{position:relative;overflow:hidden;border-radius:3px}.ba-common-datepicker .transition-container--horizontal{transition:height 0.2s ease-in-out}.ba-common-datepicker .transition-container--vertical{width:100%}.ba-common-datepicker .DayPickerNavigation__next,.ba-common-datepicker .DayPickerNavigation__prev{border:none;background-color:transparent;cursor:pointer;line-height:0.78;padding-bottom:3px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ba-common-datepicker .DayPickerNavigation__next--default,.ba-common-datepicker .DayPickerNavigation__prev--default{border:1px solid #dce0e0;color:#757575}.ba-common-datepicker .DayPickerNavigation__next--default:focus,.ba-common-datepicker .DayPickerNavigation__next--default:hover,.ba-common-datepicker .DayPickerNavigation__prev--default:focus,.ba-common-datepicker .DayPickerNavigation__prev--default:hover{border:1px solid #c4c4c4}.ba-common-datepicker .DayPickerNavigation__next--default:active,.ba-common-datepicker .DayPickerNavigation__prev--default:active{background:#f2f2f2}.ba-common-datepicker .DayPickerNavigation--horizontal{position:relative}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__next,.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__prev{border-radius:3px;top:16px;z-index:2;position:absolute}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__prev{left:22px}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__prev--rtl{left:auto;right:22px}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__next{right:22px}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__next--rtl{right:auto;left:22px}.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__next--default svg,.ba-common-datepicker .DayPickerNavigation--horizontal .DayPickerNavigation__prev--default svg{height:19px;width:19px;fill:#82888a}.ba-common-datepicker .DayPickerNavigation--vertical{box-shadow:0 0 5px 2px rgba(0,0,0,0.1);position:absolute;bottom:0;left:0;height:52px;width:100%;z-index:2}.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__next,.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__prev{display:inline-block;position:relative;height:100%;width:50%}.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__next--default{border-left:0}.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__next--default,.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__prev--default{text-align:center;font-size:2.5em;padding:5px}.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__next--default svg,.ba-common-datepicker .DayPickerNavigation--vertical .DayPickerNavigation__prev--default svg{height:42px;width:42px;fill:#484848}.ba-common-datepicker .DayPickerNavigation--vertical-scrollable{position:relative}.ba-common-datepicker .DayPickerNavigation--vertical-scrollable .DayPickerNavigation__next{width:100%}.ba-common-datepicker .DayPickerKeyboardShortcuts__close,.ba-common-datepicker .DayPickerKeyboardShortcuts__show{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer}.ba-common-datepicker .DayPickerKeyboardShortcuts__close:active,.ba-common-datepicker .DayPickerKeyboardShortcuts__show:active{outline:none}.ba-common-datepicker .DayPickerKeyboardShortcuts__show{width:22px;position:absolute;z-index:2}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--bottom-right{border-top:26px solid transparent;bottom:0;right:0}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--bottom-right .DayPickerKeyboardShortcuts__show_span{bottom:0;right:-28px}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-right{border-bottom:26px solid transparent;border-right:33px solid #00a699;top:0;right:0}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-right:hover{border-right:33px solid #008489}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-right .DayPickerKeyboardShortcuts__show_span{top:1px;right:-28px}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-left{border-bottom:26px solid transparent;border-left:33px solid #00a699;top:0;left:0}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-left:hover{border-left:33px solid #008489}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--top-left .DayPickerKeyboardShortcuts__show_span{top:1px;left:-28px}.ba-common-datepicker .DayPickerKeyboardShortcuts__show_span{position:absolute}.ba-common-datepicker .DayPickerKeyboardShortcuts__panel{overflow:auto;border:1px solid #dbdbdb;border-radius:2px;position:absolute;top:0;bottom:0;right:0;left:0;z-index:2;padding:22px;margin:33px}.ba-common-datepicker .DayPickerKeyboardShortcuts__title{font-size:16px;font-weight:600;margin:0}.ba-common-datepicker .DayPickerKeyboardShortcuts__list{list-style:none;padding:0}.ba-common-datepicker .DayPickerKeyboardShortcuts__close{position:absolute;right:22px;top:22px;z-index:2}.ba-common-datepicker .DayPickerKeyboardShortcuts__close svg{height:15px;width:15px}.ba-common-datepicker .DayPickerKeyboardShortcuts__close svg:focus,.ba-common-datepicker .DayPickerKeyboardShortcuts__close svg:hover{fill:#82888a}.ba-common-datepicker .DayPickerKeyboardShortcuts__close:active{outline:none}.ba-common-datepicker .KeyboardShortcutRow{margin:6px 0}.ba-common-datepicker .KeyboardShortcutRow__key-container{display:inline-block;white-space:nowrap;text-align:right;margin-right:6px}.ba-common-datepicker .KeyboardShortcutRow__key{font-family:monospace;font-size:12px;text-transform:uppercase;background:#f2f2f2;padding:2px 6px}.ba-common-datepicker .KeyboardShortcutRow__action{display:inline;word-break:break-word;margin-left:8px}.ba-common-datepicker .DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow{margin-bottom:16px}.ba-common-datepicker .DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow__key-container{width:auto;text-align:left;display:inline}.ba-common-datepicker .DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow__action{display:inline}.ba-common-datepicker .DateInput{font-size:12px;line-height:24px;margin:0;position:relative;display:inline-block;vertical-align:middle;height:39px;width:95px}.ba-common-datepicker .DateInput--open-down.DateInput--with-caret::after,.ba-common-datepicker .DateInput--open-down.DateInput--with-caret::before{border-top:0}.ba-common-datepicker .DateInput--open-down.DateInput--with-caret::before{top:62px;border-bottom-color:rgba(0,0,0,0.1)}.ba-common-datepicker .DateInput--open-down.DateInput--with-caret::after{top:63px}.ba-common-datepicker .DateInput--open-up.DateInput--with-caret::after,.ba-common-datepicker .DateInput--open-up.DateInput--with-caret::before{border-bottom:0}.ba-common-datepicker .DateInput--open-up.DateInput--with-caret::before{top:-24px;border-top-color:rgba(0,0,0,0.1)}.ba-common-datepicker .DateInput--open-up.DateInput--with-caret::after{top:-25px}.ba-common-datepicker .DateInput__input{font-family:'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace;font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.32px;position:absolute;top:0;left:0;border:0;height:100%;width:100%}.ba-common-datepicker .DateInput__input[readonly]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ba-common-datepicker .DateInput__display-text{font-family:\"IBM Plex Sans\",Helvetica,Arial,sans-serif;padding:8px;white-space:nowrap;overflow:hidden}.ba-common-datepicker .DateInput__display-text--has-input{text-align:center}.ba-common-datepicker .DateInput__display-text--disabled{font-style:italic}.ba-common-datepicker .screen-reader-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.ba-common-datepicker .DateRangePicker{position:relative;display:inline-block}.ba-common-datepicker .SingleDatePickerInput--disabled button,.ba-common-datepicker .SingleDatePickerInput--disabled input,.ba-common-datepicker .DateRangePickerInput--disabled button,.ba-common-datepicker .DateRangePickerInput--disabled input{cursor:not-allowed}.ba-common-datepicker .DateRangePicker__picker{z-index:2;position:absolute;direction:ltr}.ba-common-datepicker .DateRangePicker__picker--rtl{direction:rtl}.ba-common-datepicker .DateRangePicker__picker--direction-left{left:0}.ba-common-datepicker .DateRangePicker__picker--direction-right{right:0}.ba-common-datepicker .DateRangePicker__picker--open-down{top:inherit}.ba-common-datepicker .DateRangePicker__picker--open-up{bottom:72px}.ba-common-datepicker .DateRangePicker__picker--portal{background-color:rgba(0,0,0,0.3);position:fixed;top:0;left:0;height:100%;width:100%}.ba-common-datepicker .DateRangePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.ba-common-datepicker .DateRangePicker__close svg{height:15px;width:15px}.ba-common-datepicker .DateRangePicker__close:focus,.ba-common-datepicker .DateRangePicker__close:hover{color:#b0b3b4;text-decoration:none}.ba-common-datepicker .DateRangePickerInput{display:inline-block;padding:0 16px;direction:ltr}.ba-common-datepicker .DateRangePickerInput--rtl{direction:rtl;padding-right:0}.ba-common-datepicker .DateRangePickerInput--rtl .DateInput{margin-right:8px}.ba-common-datepicker .DateRangePickerInput--rtl .DateInput__input{margin:0}.ba-common-datepicker .DateRangePickerInput--rtl .DateRangePickerInput__calendar-icon{margin-left:0;margin-right:16px}.ba-common-datepicker .DateRangePickerInput__arrow{display:inline-block;vertical-align:middle;padding-right:24px;padding-left:6px}.ba-common-datepicker .DateRangePickerInput__arrow svg{vertical-align:middle;fill:#484848;height:16px;width:16px}.ba-common-datepicker .DateRangePickerInput__clear-dates{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 10px 0 5px}.ba-common-datepicker .DateRangePickerInput__clear-dates svg{fill:#82888a;height:12px;width:15px;vertical-align:middle}.ba-common-datepicker .DateRangePickerInput__clear-dates--hide{visibility:hidden}.ba-common-datepicker .DateRangePickerInput__clear-dates--hover,.ba-common-datepicker .DateRangePickerInput__clear-dates:focus{background:#dbdbdb;border-radius:50%}.ba-common-datepicker .DateRangePickerInput__calendar-icon{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;padding:0;margin-left:6px}.ba-common-datepicker .DateRangePickerInput__calendar-icon svg{vertical-align:middle}.ba-common-datepicker .SingleDatePicker{position:relative;display:inline-block;width:160px}.ba-common-datepicker .SingleDatePicker__picker{z-index:501;position:absolute;direction:ltr}.ba-common-datepicker .SingleDatePicker__picker--rtl{direction:rtl}.ba-common-datepicker .SingleDatePicker__picker--direction-left{left:0}.ba-common-datepicker .SingleDatePicker__picker--direction-right{right:0}.ba-common-datepicker .SingleDatePicker__picker--open-down{top:inherit}.ba-common-datepicker .SingleDatePicker__picker--open-up{bottom:72px}.ba-common-datepicker .SingleDatePicker__picker--portal{background-color:rgba(0,0,0,0.3);position:fixed;top:0;left:0;height:100%;width:100%}.ba-common-datepicker .SingleDatePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.ba-common-datepicker .SingleDatePicker__close svg{height:15px;width:15px}.ba-common-datepicker .SingleDatePicker__close:focus,.ba-common-datepicker .SingleDatePicker__close:hover{color:#b0b3b4;text-decoration:none}.ba-common-datepicker .SingleDatePickerInput{direction:ltr;padding:0 16px}.ba-common-datepicker .SingleDatePickerInput--rtl{direction:rtl}.ba-common-datepicker .SingleDatePickerInput__clear-date{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 10px 0 5px}.ba-common-datepicker .SingleDatePickerInput__clear-date svg{fill:#82888a;height:12px;width:15px;vertical-align:middle}.ba-common-datepicker .SingleDatePickerInput__clear-date--hide{visibility:hidden}.ba-common-datepicker .SingleDatePickerInput__clear-date--hover,.ba-common-datepicker .SingleDatePickerInput__clear-date:focus{background:#dbdbdb;border-radius:50%}.ba-common-datepicker .SingleDatePickerInput__calendar-icon{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;padding:0;margin-left:6px}.ba-common-datepicker .SingleDatePickerInput--rtl .SingleDatePickerInput__calendar-icon{margin-left:0;margin-right:16px}.ba-common-datepicker .SingleDatePickerInput--rtl .DateInput{margin-right:8px}.ba-common-datepicker .SingleDatePickerInput__calendar-icon svg{vertical-align:middle}.ba-common-datepicker .DayPickerNavigation__next,.ba-common-datepicker .DayPickerNavigation__prev{top:12px !important}.ba-common-datepicker{border-bottom:1px solid;color:#8d8d8d;color:hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1)}.ba-common-datepicker .CalendarDay--highlighted-calendar{color:#595859}.ba-common-datepicker .CalendarDay--outside:active{background:#fff}.ba-common-datepicker .CalendarDay--blocked-minimum-nights{color:#c0bfc0;background:#fff}.ba-common-datepicker .CalendarDay--blocked-minimum-nights:active{background:#fff}.ba-common-datepicker .CalendarDay--after-hovered-start:active,.ba-common-datepicker .CalendarDay--hovered-span:active{background:#1f57a4;background:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1);color:#fff}.ba-common-datepicker .CalendarDay--hovered{background:#e5e5e5;background:hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1)}@media screen and (-ms-high-contrast: active){.ba-common-datepicker .CalendarDay--hovered button{border:2px #737173 solid;background-color:#737173}}.ba-common-datepicker .CalendarDay--selected,.ba-common-datepicker .CalendarDay--selected-end,.ba-common-datepicker .CalendarDay--selected-start{background:#0f62fe;background:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);color:#fff}@media screen and (-ms-high-contrast: active){.ba-common-datepicker .CalendarDay--selected button,.ba-common-datepicker .CalendarDay--selected-end button,.ba-common-datepicker .CalendarDay--selected-start button{background-color:#1f57a4;background-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1);color:#000}}.ba-common-datepicker .CalendarDay--selected-span{background-color:#edf5ff;background-color:hsla(var(--highlight-h, 213.33333), var(--highlight-s, 100%), var(--highlight-l, 96.47059%), 1)}@media screen and (-ms-high-contrast: active){.ba-common-datepicker .CalendarDay--selected-span button{border:2px #737173 solid;background-color:#737173}}.ba-common-datepicker .CalendarDay--selected-end:active,.ba-common-datepicker .CalendarDay--selected-start:active,.ba-common-datepicker .CalendarDay--selected:active{background:#0f62fe;background:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-common-datepicker .CalendarDay--blocked-calendar{background:#c0bfc0}.ba-common-datepicker .CalendarDay--blocked-calendar:active{background:#c0bfc0}.ba-common-datepicker .CalendarDay--blocked-out-of-range{color:#c0bfc0}.ba-common-datepicker .CalendarDay--blocked-out-of-range:active{color:#595859;background:#fff}.ba-common-datepicker .CalendarMonthGrid{background:#fff}.ba-common-datepicker .DayPicker{background:#fff}.ba-common-datepicker .DayPicker--horizontal{background:#fff}.ba-common-datepicker .DayPicker__week-header li{color:#343334}.ba-common-datepicker .DayPickerNavigation__next,.ba-common-datepicker .DayPickerNavigation__prev{color:#595859}.ba-common-datepicker .DayPickerNavigation__next--default,.ba-common-datepicker .DayPickerNavigation__prev--default{background-color:#fff}.ba-common-datepicker .DayPickerNavigation--vertical{background:#fff;box-shadow:0 0 5px 2px rgba(0,0,0,0.1)}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--bottom-right{border-right:33px solid;border-right-color:#1f57a4;border-right-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}.ba-common-datepicker .DayPickerKeyboardShortcuts__show--bottom-right:hover{border-right:33px solid;border-right-color:#2d74da;border-right-color:hsla(var(--primary2-h, 215.37572), var(--primary2-s, 70.04049%), var(--primary2-l, 51.56863%), 1)}.ba-common-datepicker .DayPickerKeyboardShortcuts__show_span{color:#fff}.ba-common-datepicker .DayPickerKeyboardShortcuts__panel{background:#fff}.ba-common-datepicker .DayPickerKeyboardShortcuts__close svg{fill:#c0bfc0}.ba-common-datepicker .DateInput--open-down.DateInput--with-caret::after{border-bottom-color:#fff}.ba-common-datepicker .DateInput--open-up.DateInput--with-caret::after{border-top-color:#fff}.ba-common-datepicker .DateInput__input{background-color:#fff;background-color:hsla(var(--field-01-h, 0), var(--field-01-s, 0%), var(--field-01-l, 100%), 1);color:#343334}.ba-common-datepicker.is-light .DateInput__input{background-color:#f4f4f4;background-color:hsla(var(--field-02-h, 0), var(--field-02-s, 0%), var(--field-02-l, 95.68627%), 1)}.ba-common-datepicker .DateInput__display-text--has-input{color:#343334}.ba-common-datepicker .DateRangePicker__picker{background-color:#fff}.ba-common-datepicker .DateRangePicker__picker--full-screen-portal{background-color:#fff}.ba-common-datepicker .DateRangePicker__close svg{fill:#c0bfc0}.ba-common-datepicker .DateRangePickerInput{background-color:#fff;background-color:hsla(var(--field-01-h, 0), var(--field-01-s, 0%), var(--field-01-l, 100%), 1)}.ba-common-datepicker.is-light .DateRangePickerInput{background-color:#f4f4f4;background-color:hsla(var(--field-02-h, 0), var(--field-02-s, 0%), var(--field-02-l, 95.68627%), 1)}.ba-common-datepicker .SingleDatePicker__picker{background-color:#fff}.ba-common-datepicker .SingleDatePicker__picker--full-screen-portal{background-color:#fff}.ba-common-datepicker .SingleDatePicker__close svg{fill:#c0bfc0}.ba-common-datepicker .SingleDatePickerInput{background-color:#fff;background-color:hsla(var(--field-01-h, 0), var(--field-01-s, 0%), var(--field-01-l, 100%), 1)}.ba-common-datepicker.is-light .SingleDatePickerInput{background-color:#f4f4f4;background-color:hsla(var(--field-02-h, 0), var(--field-02-s, 0%), var(--field-02-l, 95.68627%), 1)}.ba-common-datepicker .SingleDatePickerInput svg,.ba-common-datepicker .DateRangePickerInput svg{fill:#595859}@media screen and (-ms-high-contrast: active){.ba-common-datepicker .SingleDatePickerInput svg,.ba-common-datepicker .DateRangePickerInput svg{fill:#fff}}.ba-common-datepicker .DayPickerNavigation__next:hover .ba-common-svgIcon,.ba-common-datepicker .DayPickerNavigation__prev:hover .ba-common-svgIcon{background-color:#e5e5e5;background-color:hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1)}.ba-common-datepicker .SingleDatePickerInput--disabled,.ba-common-datepicker .DateRangePickerInput--disabled{opacity:.5}.ba-common-datepicker .SingleDatePickerInput--disabled:hover .ba-common-svgIcon,.ba-common-datepicker .DateRangePickerInput--disabled:hover .ba-common-svgIcon{fill:#595859}.ba-common-datepicker .CalendarMonth__caption{color:#343334}\n", ""]);

// exports
exports.locals = {
	"datepickerClassName": "\"ba-common-datepicker\""
};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(53));

var _reactDates = __webpack_require__(94);

var _moment = _interopRequireDefault(__webpack_require__(60));

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _calendar_ = _interopRequireDefault(__webpack_require__(96));

var _withCommon = _interopRequireDefault(__webpack_require__(95));

var _dec, _class, _class2, _temp;

var sanitize = _utils.propsUtils.sanitize;
var lang;

if (document.documentElement && document.documentElement.lang) {
  lang = document.documentElement.lang; // The locale key for Norwegian differs between Cognos and Moment

  if (lang === 'no') {
    lang = 'nb';
  }
}

var RangeDatepicker = (_dec = (0, _withCommon["default"])({
  locale: lang
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(RangeDatepicker, _Component);

  function RangeDatepicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      typedDates: {},
      focusedInput: _this.props.focusedInput,
      lastValidDates: {
        startDate: _this.props.startDate,
        endDate: _this.props.endDate
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dateRangeRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focusController", function (toBeFocused) {
      var newState = {
        focusedInput: toBeFocused
      };
      var onFocusChange = _this.props.onFocusChange;
      var typedDates = _this.state.typedDates;
      var validTypeDates = (0, _extends2["default"])({}, _this.state.lastValidDates);

      if (typedDates.startDate && (0, _moment["default"])(typedDates.startDate, [_moment["default"].ISO_8601, _moment["default"].RFC_2822]).isValid()) {
        validTypeDates.startDate = (0, _moment["default"])(typedDates.startDate);
      }

      if (typedDates.endDate && (0, _moment["default"])(typedDates.endDate, [_moment["default"].ISO_8601, _moment["default"].RFC_2822]).isValid()) {
        validTypeDates.endDate = (0, _moment["default"])(typedDates.endDate);
      }

      newState.startDate = validTypeDates.startDate;
      newState.endDate = validTypeDates.endDate;

      _this.setState(newState);

      onFocusChange && onFocusChange(toBeFocused);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyUp", function (event) {
      event.persist();

      if (event.keyCode === 27) {
        _this._focusController(null);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (e) {
      var typedDates = _this.state.typedDates;
      var newTypedDates = typedDates;
      newTypedDates[e.target.id] = e.target.value;

      _this.setState({
        typedDates: newTypedDates
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onDatesChange", function (date) {
      // eslint-disable-no-shadow
      var onChange = _this.props.onChange;
      onChange({
        startDate: date.startDate,
        endDate: date.endDate
      });

      if (_this.dateRangeRef.current.props.focusedInput === 'endDate') {
        _this.dateRangeRef.current.onDateRangePickerInputFocus('startDate');
      }
    });
    return _this;
  }

  var _proto = RangeDatepicker.prototype;

  _proto._renderMonth = function _renderMonth(month) {
    return month.locale(this.props.locale).format(this.props.commonProps.monthFormat);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        renderDay = _this$props.renderDay,
        renderMonth = _this$props.renderMonth,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        commonProps = _this$props.commonProps,
        disabled = _this$props.disabled,
        startDatePlaceholderText = _this$props.startDatePlaceholderText,
        endDatePlaceholderText = _this$props.endDatePlaceholderText,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["renderDay", "renderMonth", "startDate", "endDate", "commonProps", "disabled", "startDatePlaceholderText", "endDatePlaceholderText", "light"]);
    var focusedInput = this.state.focusedInput;
    var calenderProps = {}; // for defect https://jsw.ibm.com/browse/BATOOLKIT-2274

    startDate && startDate.locale(lang);
    endDate && endDate.locale(lang);
    var cProps = (0, _extends2["default"])({}, sanitize(others, RangeDatepicker), {
      disabled: disabled,
      startDate: startDate,
      endDate: endDate,
      focusedInput: focusedInput,
      renderMonth: renderMonth,
      renderDay: renderDay,
      startDatePlaceholderText: startDatePlaceholderText,
      endDatePlaceholderText: endDatePlaceholderText,
      // displayFormat,
      onFocusChange: function onFocusChange(f) {
        _this2._focusController(f);
      },
      onDatesChange: this._onDatesChange,
      keepOpenOnDateSelect: true,
      customArrowIcon: /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        iconId: _calendar_["default"].id
      })
    }, commonProps, calenderProps);
    cProps.renderMonth = cProps.renderMonth || this._renderMonth.bind(this);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)('ba-common-datepicker', {
        open: !!focusedInput,
        light: light
      }),
      onKeyUp: this._onKeyUp,
      onChange: this._onChange
    }, /*#__PURE__*/_react["default"].createElement(_reactDates.DateRangePicker, (0, _extends2["default"])({
      ref: this.dateRangeRef
    }, cProps)));
  };

  return RangeDatepicker;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", (0, _extends2["default"])({
  focusedInput: _propTypes["default"].oneOf(['startDate', 'endDate']),

  /** momentPropTypes.momentObj */
  startDate: _reactMomentProptypes["default"].momentObj,

  /** momentPropTypes.momentObj */
  endDate: _reactMomentProptypes["default"].momentObj,

  /** Format */
  displayFormat: _propTypes["default"].string,

  /** Format */
  monthFormat: _propTypes["default"].string,
  renderMonth: _propTypes["default"].func,

  /** Callback function */
  onFocusChange: _propTypes["default"].func,

  /** Callback function */
  onChange: _propTypes["default"].func,

  /** Placeholder text when no start date is selected */
  startDatePlaceholderText: _propTypes["default"].string,

  /** Placeholder text when no start date is selected */
  endDatePlaceholderText: _propTypes["default"].string
}, (0, _withCommon["default"])()().propTypes)), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  onFocusChange: function onFocusChange() {},
  onChange: function onChange() {},
  focusedInput: null
}), _temp)) || _class);
exports["default"] = RangeDatepicker;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = require("react-moment-proptypes");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-right_16");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports = require("react-dates");

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = WithCommon;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _moment = _interopRequireDefault(__webpack_require__(60));

var _momentJalaali = _interopRequireDefault(__webpack_require__(222));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _chevronRight_ = _interopRequireDefault(__webpack_require__(61));

var _calendar_ = _interopRequireDefault(__webpack_require__(96));

var _StringResource = _interopRequireDefault(__webpack_require__(223));

__webpack_require__(225);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var GENERAL_MONTH_FORMAT = 'MMM YYYY';
var GENERAL_LONG_DATE_FORMAT = 'YYYY-MM-DD';

function WithCommon() {
  return function (WrappedComponent) {
    var WithDatepicker = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(WithDatepicker, _Component);

      function WithDatepicker() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = WithDatepicker.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            isRTL = _this$props.isRTL,
            numberOfMonths = _this$props.numberOfMonths,
            isOutsideRange = _this$props.isOutsideRange,
            customInputIcon = _this$props.customInputIcon,
            customNavNext = _this$props.customNavNext,
            customNavPrev = _this$props.customNavPrev,
            monthFormat = _this$props.monthFormat,
            locale = _this$props.locale,
            hijri = _this$props.hijri,
            className = _this$props.className,
            style = _this$props.style; // do spicific modification based on spicific locale

        var rProps = {}; // set locale, translation

        if (locale) {
          _moment["default"].locale(locale); // spicify


          if (locale.startsWith('zh') || locale.startsWith('ja')) {
            rProps.renderMonth = function (month) {
              return (0, _moment["default"])(month).format("YYYY[" + _StringResource["default"].get('year') + "] MMMM");
            };
          }
        } else {
          _moment["default"].locale(); // automatically detect

        }

        if (hijri) {
          rProps.renderDay = function (day) {
            return (0, _momentJalaali["default"])(day).format('jDD');
          };

          rProps.renderMonth = function (month) {
            return (0, _momentJalaali["default"])(month).format('jMMMM jYYYY');
          };
        }

        var commonProps = (0, _extends2["default"])({
          daySize: 32,
          hideKeyboardShortcutsPanel: true,
          customInputIcon: customInputIcon || /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            iconId: _calendar_["default"].id
          }),
          inputIconPosition: 'after',
          navNext: customNavNext || (isRTL ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            iconId: _chevronRight_["default"].id,
            rotate: 180
          }) : /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            iconId: _chevronRight_["default"].id
          })),
          navPrev: customNavPrev || (isRTL ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            iconId: _chevronRight_["default"].id
          }) : /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            iconId: _chevronRight_["default"].id,
            rotate: 180
          })),
          displayFormat: GENERAL_LONG_DATE_FORMAT,
          monthFormat: monthFormat || GENERAL_MONTH_FORMAT,
          isRTL: isRTL,
          numberOfMonths: numberOfMonths,
          isOutsideRange: isOutsideRange
        }, rProps);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "ba-common-datepicker-container " + className,
          style: style,
          onFocus: this._onFocus
        }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
          key: WrappedComponent.name
        }, this.props, {
          commonProps: commonProps
        })));
      };

      return WithDatepicker;
    }(_react.Component);

    (0, _defineProperty2["default"])(WithDatepicker, "propTypes", {
      // View:
      isRTL: _propTypes["default"].bool,
      numberOfMonths: _propTypes["default"].number,
      hideKeyboardShortcutsPanel: _propTypes["default"].bool,
      isOutsideRange: _propTypes["default"].func,
      // CustomNode
      customInputIcon: _propTypes["default"].element,
      customNavNext: _propTypes["default"].element,
      customNavPrev: _propTypes["default"].element,
      // Format
      displayFormat: _propTypes["default"].string,
      monthFormat: _propTypes["default"].string,
      // Internationalization
      locale: _propTypes["default"].string,
      // canlender
      hijri: _propTypes["default"].bool,
      disabled: _propTypes["default"].bool,
      className: _propTypes["default"].string,
      style: _propTypes["default"].object
    });
    (0, _defineProperty2["default"])(WithDatepicker, "defaultProps", {
      isOutsideRange: function isOutsideRange() {
        return false;
      },
      className: '',
      style: {}
    });
    return WithDatepicker;
  };
}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/calendar_32");

/***/ })

},[[219,0]]]);
});